module.exports = __webpack_public_path__ + "img/annualFront.548beca7.png";